import React from 'react';
import { LANGS, makeT } from './i18n.js';

/** Üst gezinmedeki dil seçici. Ayrı dosya: App ↔ Login döngüsü olmasın. */
export default function LangPicker({ lang, onPick, style }) {
  const t = makeT(lang);
  return (
    <select aria-label={t('language')} value={lang} title={t('language')}
      style={{ width: 'auto', padding: '6px 8px', ...style }}
      onChange={(e) => onPick(e.target.value)}>
      {LANGS.map((l) => <option key={l.code} value={l.code}>{l.label}</option>)}
    </select>
  );
}
